<script setup lang="ts">
import { DropdownMenuCheckboxItem } from 'reka-ui'

defineProps<{ modelValue: boolean; label: string; description: string }>()
const emit = defineEmits<{ 'update:modelValue': [value: boolean] }>()
</script>

<template>
  <DropdownMenuCheckboxItem
    :model-value="modelValue"
    class="flex w-full cursor-pointer select-none items-start gap-[var(--space-cell)] rounded-[var(--radius-control)] px-[var(--space-cell)] py-[var(--space-inline)] text-left outline-none data-[highlighted]:bg-[color:var(--color-surface-raised)]"
    @select.prevent
    @update:model-value="emit('update:modelValue', $event === true)"
  >
    <span class="mt-0.5 shrink-0 text-[color:var(--color-text-muted)]"><slot name="icon" /></span>
    <span class="flex min-w-0 flex-1 flex-col">
      <span class="text-[length:var(--text-step-3)] text-[color:var(--color-text)]">{{ label }}</span>
      <span class="text-[length:var(--text-step-1)] text-[color:var(--color-text-muted)]">{{
        description
      }}</span>
    </span>
    <span
      aria-hidden="true"
      class="mt-0.5 flex h-5 w-9 shrink-0 items-center rounded-full p-0.5 transition-colors duration-[var(--motion-fast)]"
      :class="modelValue ? 'bg-[color:var(--color-action)]' : 'bg-[color:var(--color-border-control)]'"
    >
      <span
        class="h-4 w-4 rounded-full bg-[color:var(--color-surface)] shadow transition-transform duration-[var(--motion-fast)]"
        :class="modelValue ? 'translate-x-4' : ''"
      />
    </span>
  </DropdownMenuCheckboxItem>
</template>
